module.exports = __webpack_public_path__ + "static/media/di_ecokz.0dd496b8.pdf";